import type { Location } from 'history';
import { isExternalPath, isReactPath } from './routing';
import captureException from './captureException';

/**
 * Extracts the next url encoded in the query params.
 * Defaults to the home page if there is no valid `next` param.
 */
const getNextUrl = (location: Pick<Location, 'search'>): string => {
  // Use URLSearchParams only, which handles both decoding and multiple values
  const params = new URLSearchParams(location.search);
  const target = params.get('next');

  if (!target) {
    return '/';
  }

  // Validate the URL
  if (isReactPath(target) || isExternalPath(target)) {
    return target;
  }

  if (target !== '/') {
    // Report any url redirects that have not been processed, as these are likely suspicious.
    captureException(new Error('Invalid next url'), {
      extra: {
        target,
      },
    });
  }

  // Default to the home page
  return '/';
};

export default getNextUrl;
